import gql from 'graphql-tag';

export const M_SET_CALL_FLOW_TO_PERSON = gql`
  mutation($phoneNumberId: Int!, $userId: Int!) {
    update_callflows(
      where: { phone_number_id: { _eq: $phoneNumberId } }
      _set: { user_id: $userId, group_id: null, open_flow: null, closed_flow: null, working_hours: null }
    ) {
      affected_rows
    }
  }
`;

export const M_SET_CALL_FLOW_TO_GROUP = gql`
  mutation($phoneNumberId: Int!, $groupId: Int) {
    update_callflows(
      where: { phone_number_id: { _eq: $phoneNumberId } }
      _set: { user_id: null, group_id: $groupId, open_flow: null, closed_flow: null, working_hours: null }
    ) {
      affected_rows
    }
  }
`;

export const M_SET_CALL_FLOW_TO_MENU = gql`
  mutation($phoneNumberId: Int!, $openFlow: String!, $closedFlow: String, $workingHours: String) {
    update_callflows(
      where: { phone_number_id: { _eq: $phoneNumberId } }
      _set: {
        user_id: null
        group_id: null
        open_flow: $openFlow
        closed_flow: $closedFlow
        working_hours: $workingHours
      }
    ) {
      affected_rows
    }
  }
`;

export const M_S3_GREETING_UPLOAD = gql`
  mutation {
    s3_greeting_upload {
      key
      url
    }
  }
`;
